import React from "react";
import { Link } from "react-router-dom";
import { useDemoModal } from "../hooks/useDemoModal";

// `href === "demo"` is a sentinel that opens the Book-a-Demo modal instead of navigating.
const LINKS = {
    Product:  [["Dashboard", "/login"], ["Invoicing", "/login"], ["Bank reconciliation", "/login"], ["GST filing", "/login"], ["AI Copilot", "/#copilot"]],
    Company:  [["About", "/about"], ["Contact", "demo"]],
    Legal:    [["Privacy", "/legal/privacy"], ["Terms", "/legal/terms"], ["Security", "/legal/security"]],
};

const slug = (label) => label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

function FooterLink({ href, children }) {
    const { openModal } = useDemoModal();
    const testid = `footer-link-${slug(children)}`;
    if (href === "demo") {
        return (
            <button
                type="button"
                onClick={openModal}
                data-testid={testid}
                style={{ background: "none", border: 0, padding: 0, cursor: "pointer", color: "inherit", font: "inherit", textAlign: "left" }}
            >
                {children}
            </button>
        );
    }
    // External / anchor / mailto → plain <a>. Internal SPA route → <Link> for client-side nav.
    const isExternal = href.startsWith("mailto:") || href.startsWith("/api/") || href.startsWith("#") || href.startsWith("http");
    if (isExternal) {
        return <a href={href} data-testid={testid}>{children}</a>;
    }
    return <Link to={href} data-testid={testid}>{children}</Link>;
}

export default function Footer() {
    return (
        <footer className="vy-footer" data-testid="landing-footer">
            <div className="vy-container">
                <div style={{ display: "grid", gridTemplateColumns: "1.6fr repeat(3, 1fr)", gap: 32 }} className="vy-grid-3">
                    <div>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }} data-testid="footer-logo">
                            <img
                                src="/vyaahar-logo.png"
                                alt="Vyaahar"
                                style={{ height: 30, width: "auto", display: "block", filter: "brightness(0) invert(1)" }}
                            />
                        </div>
                        <p style={{ marginTop: 12, fontSize: 13, lineHeight: 1.65, color: "rgba(246,242,235,0.65)", maxWidth: 320 }}>
                            Finance, books &amp; compliance — in one system.
                        </p>
                        <p
                            style={{
                                marginTop: 20, fontSize: 12, lineHeight: 1.7, color: "rgba(246,242,235,0.55)",
                                borderLeft: "1px solid rgba(166,138,86,0.4)", paddingLeft: 14, maxWidth: 340, fontStyle: "italic",
                            }}
                            data-testid="footer-founder-note"
                        >
                            Built in Chennai by finance operators who got tired of stitching four tools together.
                        </p>
                    </div>
                    {Object.entries(LINKS).map(([section, items]) => (
                        <div key={section}>
                            <div className="vy-kicker">{section}</div>
                            <ul style={{ listStyle: "none", padding: 0, margin: "14px 0 0", display: "grid", gap: 10 }}>
                                {items.map(([label, href]) => (
                                    <li key={label} style={{ fontSize: 13 }}>
                                        <FooterLink href={href}>{label}</FooterLink>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                <div style={{ marginTop: 48, paddingTop: 22, borderTop: "1px solid rgba(246,242,235,0.12)", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
                    <div style={{ fontSize: 11.5, color: "rgba(246,242,235,0.5)", fontFamily: "IBM Plex Mono, monospace" }} data-testid="footer-copyright">
                        © {new Date().getFullYear()} Vyastics Technologies Private Limited · Chennai, India
                        <span style={{ margin: "0 8px", color: "rgba(246,242,235,0.28)" }}>·</span>
                        <span data-testid="footer-scitus">Vyaahar is a product of Scitus.ai</span>
                    </div>
                    <div style={{ fontSize: 11.5, color: "rgba(246,242,235,0.5)", fontFamily: "IBM Plex Mono, monospace", display: "flex", gap: 16 }}>
                        <span>Made in India</span>
                        <span>·</span>
                        <span>Encrypted in transit &amp; at rest</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
